// extracted by mini-css-extract-plugin
export default {"navbtn":"navbar_navbtn__6sYku","hamburger":"navbar_hamburger__8z4P0","btn":"navbar_btn__3N-Ls"};